import React from "react";

const IconHome1 = ({ color = "#e31c19" }) => {
  return (
    <svg
      id="UI_icon_home_light"
      data-name="UI icon/home/light"
      xmlns="http://www.w3.org/2000/svg"
      width="30"
      height="29.946"
      viewBox="0 0 30 29.946"
    >
      <path
        id="Union"
        d="M25.5,29.946H4.5a4.5,4.5,0,0,1-4.5-4.5v-11.5a4.506,4.506,0,0,1,1.489-3.344l10.5-9.45a4.5,4.5,0,0,1,6.021,0l10.5,9.45A4.506,4.506,0,0,1,30,13.949v11.5A4.5,4.5,0,0,1,25.5,29.946Zm-12-15h3a4.505,4.505,0,0,1,4.5,4.5v7.5h4.5a1.5,1.5,0,0,0,1.5-1.5v-11.5a1.5,1.5,0,0,0-.5-1.115L16,3.384a1.5,1.5,0,0,0-2.006,0L3.5,12.834A1.5,1.5,0,0,0,3,13.949v11.5a1.5,1.5,0,0,0,1.5,1.5H9v-7.5A4.5,4.5,0,0,1,13.5,14.946Zm0,3a1.5,1.5,0,0,0-1.5,1.5v7.5h6v-7.5a1.5,1.5,0,0,0-1.5-1.5Z"
        fill={color}
      />
    </svg>
  );
};

export default IconHome1;
